import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Button, Dropdown, DropdownCard, DropdownContent } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import { MediaLibraryStore } from 'widgets/MediaLibrary'
import { MediaLibrarySelectMode, MediaLibraryVariant } from 'widgets/MediaLibrary/types/types'
import { type VoicemailDropStore } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop'
import styles from './styles.module.scss'

type IAddVoicemailAudioButtonProps = {
  store: VoicemailDropStore
  fullWidth?: boolean
}

export const AddVoicemailAudioButton = observer(
  ({ store, fullWidth = false }: IAddVoicemailAudioButtonProps) => {
    const { handleRecordAudio, handleMediaLibrarySelect, handleTextToSpeech } = store
    const entities = useEntitiesContext()
    const presentationStore = usePresentationModeContext()

    const [mediaLibraryStore] = useState(
      () =>
        new MediaLibraryStore(
          {
            mediaLibraryVariant: MediaLibraryVariant.RinglessSelect,
            onAddAttachment: handleMediaLibrarySelect,
            selectMode: MediaLibrarySelectMode.Single,
            skipAudioDurationLimits: true,
          },
          entities,
          presentationStore
        )
    )

    return (
      <Dropdown
        className={styles.addDropdown}
        triggerComponent={() => (
          <Button
            fullWidth={fullWidth}
            text={'Add voicemail audio'}
            iconProps={{ icon: 'add' }}
            size={'medium'}
            className={styles.addButton}
            iconRightProps={{
              icon: 'chevronDown',
              className: styles.addRightIcon,
            }}
          />
        )}
        placement={'bottom-end'}
        customComponent={(onCloseMenu) => (
          <DropdownContent width={186}>
            <DropdownCard
              item={{
                id: 'record',
                label: 'Record audio',
                iconL: 'microphone',
                ariaLabel: 'recordSelector',
              }}
              onChange={() => {
                onCloseMenu()
                handleRecordAudio()
              }}
            />
            <DropdownCard
              item={{
                id: 'upload',
                label: 'Upload or select',
                iconL: 'plusCircle',
                ariaLabel: 'uploadSelector',
              }}
              onChange={() => {
                onCloseMenu()
                mediaLibraryStore.handleOpenMediaLibraryModal()
              }}
            />
            <DropdownCard
              item={{
                id: 'speech',
                label: 'Text to speech',
                iconL: 'lineType',
                ariaLabel: 'speechSelector',
              }}
              onChange={() => {
                onCloseMenu()
                handleTextToSpeech()
              }}
            />
          </DropdownContent>
        )}
      />
    )
  }
)
